/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatientInsurance } from './PatientInsurance';
import {
    PatientInsuranceFromJSON,
    PatientInsuranceFromJSONTyped,
    PatientInsuranceToJSON,
    PatientInsuranceToJSONTyped,
} from './PatientInsurance';

/**
 * 
 * @export
 * @interface PatientInfo
 */
export interface PatientInfo {
    /**
     * Patient first name
     */
    first_name: string;
    /**
     * Patient last name
     */
    last_name: string;
    /**
     * Patient date of birth
     */
    dob: string;
    /**
     * Patient gender
     */
    gender?: string;
    /**
     * Patient insurance information
     */
    insurances: Array<PatientInsurance>;
}

/**
 * Check if a given object implements the PatientInfo interface.
 */
export function instanceOfPatientInfo(value: object): value is PatientInfo {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('dob' in value) || value['dob'] === undefined) return false;
    if (!('insurances' in value) || value['insurances'] === undefined) return false;
    return true;
}

export function PatientInfoFromJSON(json: any): PatientInfo {
    return PatientInfoFromJSONTyped(json, false);
}

export function PatientInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'dob': json['dob'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'insurances': ((json['insurances'] as Array<any>).map(PatientInsuranceFromJSON)),
    };
}

export function PatientInfoToJSON(json: any): PatientInfo {
    return PatientInfoToJSONTyped(json, false);
}

export function PatientInfoToJSONTyped(value?: PatientInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'dob': value['dob'],
        'gender': value['gender'],
        'insurances': ((value['insurances'] as Array<any>).map(PatientInsuranceToJSON)),
    };
}

